<form [formGroup]="placementForm" (ngSubmit)="onSubmit()">
    <div class="feed-program mt-4">
        <h2>Feeding Program</h2>
        <p>Detail about Feeding Program</p>
        <div formArrayName="placementChicksFeedingProgram">
          <table class="feeding-program-table responsive">
            <tr>
              <th>Stage</th>
              <th>Age From(days)</th>
              <th>Age To(days)</th>
              <th>Quantity (gram/day)</th>
            </tr>
            <tr *ngFor="let feedingProgram of placementChicksFeedingProgram.controls; let i = index" [formGroupName]="i">
    
              <td><label>{{ feedingProgram.value.stageId | stageName }}</label></td>
              <td><input class="form-control" formControlName="agefrom" type="number">
                <div *ngIf="feedingProgram.get('agefrom').touched && feedingProgram.get('agefrom').invalid">
                  <small class="text-danger" *ngIf="feedingProgram.get('agefrom').errors?.required">Age from is
                    required.</small>
                  <small class="text-danger" *ngIf="feedingProgram.get('agefrom').errors?.min">Age from must be
                    non-negative.</small>
                </div>
              </td>
              <td> <input class="form-control" formControlName="ageTo" type="number">
                <div *ngIf="feedingProgram.get('ageTo').touched && feedingProgram.get('ageTo').invalid">
                  <small class="text-danger" *ngIf="feedingProgram.get('ageTo').errors?.required">Age to is
                    required.</small>
                  <small class="text-danger" *ngIf="feedingProgram.get('ageTo').errors?.min">Age from must be
                    non-negative.</small>
                </div>
                <div class="text-danger"
                  *ngIf="feedingProgram.get('agefrom').valid && feedingProgram.get('ageTo').dirty && (feedingProgram.get('agefrom').value > feedingProgram.get('ageTo').value)">
                  Age to must be greater than age from
                </div>
              </td>
              <td><input class="form-control" formControlName="chicksQty" type="number">
                <div *ngIf="feedingProgram.get('chicksQty').touched && feedingProgram.get('chicksQty').invalid">
                  <small class="text-danger" *ngIf="feedingProgram.get('chicksQty').errors?.required">Chicks quantity is
                    required.</small>
                  <small class="text-danger" *ngIf="feedingProgram.get('chicksQty').errors?.min">Chicks quantity must be
                    non-negative.</small>
                </div>
              </td>
              <!-- Assuming you have a pipe to display the stage names -->
            </tr>
          </table>
    
        </div>
      </div>
      <div class="add-placement-btn text-right">

        <button type="submit" class="btn btn-primary" [disabled]="isLoading$ | async">
          <span *ngIf="!isAuthLoading"> Update Feeding Program</span>
          <span *ngIf="isAuthLoading">Submitting...</span>
        </button>
        <img *ngIf="isLoading$ | async" src="assets/img/loader.gif" alt="Loading..." class="loader-image mt-2">
        <!-- <button class="btn btn-primary" type="submit">Create</button> -->
      </div>
</form>
